<template>
  <div class="text-xs">
    <template v-if="form.type == 10">
      <date-range-picker
        class="date-range-picker rounded-lg"
        v-model="date"
        range
        confirm
        format="YYYY-MM-DD"
        time-title-format="YYYY-MM-DD"
        type="datetime"
        :lang="{
          formatLocale: {
            months: [
              'Ocak',
              'Şubat',
              'Mart',
              'Nisan',
              'Mayıs',
              'Haziran',
              'Temmuz',
              'Ağustos',
              'Eylül',
              'Ekim',
              'Kasım',
              'Aralık',
            ],
            monthsShort: [
              'Oca',
              'Şub',
              'Mar',
              'Nis',
              'May',
              'Haz',
              'Tem',
              'Ağu',
              'Eyl',
              'Eki',
              'Kas',
              'Ara',
            ],
            weekdays: [
              'Pazar',
              'Pazartesi',
              'Salı',
              'Çarşamba',
              'Perşembe',
              'Cuma',
              'Cumartesi',
            ],
            weekdaysShort: ['Paz', 'Pts', 'Sal', 'Çar', 'Per', 'Cum', 'Cts'],
            weekdaysMin: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
            firstDayOfWeek: 1,
            firstWeekContainsDate: 7,
          },
        }"
      />
    </template>
    <template v-else>
      <template v-if="specialDate == false">
        <select class="uk-select" v-model="cDate">
          <option value="bugun">Bugün</option>
          <option value="1">Dün</option>
          <option value="2">2 Gün</option>
          <option value="3">3 Gün</option>
          <option value="4">4 Gün</option>
          <option value="5">5 Gün</option>
          <option value="6">6 Gün</option>
          <option value="7">1 Hafta</option>
          <option value="14">2 Hafta</option>
          <option value="21">3 Hafta</option>
          <option value="buay">Mevcut ay başı</option>
          <option value="30">1 AY (30 gün)</option>
          <option value="60">2 AY (60 gün)</option>
          <option value="90">3 AY (90 gün)</option>
          <option value="120">4 AY (120 gün)</option>
          <option value="150">5 AY (150 gün)</option>
          <option value="180">6 AY (180 gün)</option>
          <option value="999">Özel Tarih</option>
        </select>
      </template>
      <template v-else>
        <date-range-picker
          :placeholder="date"
          class="date-range-picker rounded-lg"
          v-model="date"
          value-type="date"
          format="YYYY-MM-DD"
          confirm
          time-title-format="YYYY-MM-DD"
          type="datetime"
          :lang="{
            formatLocale: {
              months: [
                'Ocak',
                'Şubat',
                'Mart',
                'Nisan',
                'Mayıs',
                'Haziran',
                'Temmuz',
                'Ağustos',
                'Eylül',
                'Ekim',
                'Kasım',
                'Aralık',
              ],
              monthsShort: [
                'Oca',
                'Şub',
                'Mar',
                'Nis',
                'May',
                'Haz',
                'Tem',
                'Ağu',
                'Eyl',
                'Eki',
                'Kas',
                'Ara',
              ],
              weekdays: [
                'Pazar',
                'Pazartesi',
                'Salı',
                'Çarşamba',
                'Perşembe',
                'Cuma',
                'Cumartesi',
              ],
              weekdaysShort: ['Paz', 'Pts', 'Sal', 'Çar', 'Per', 'Cum', 'Cts'],
              weekdaysMin: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
              firstDayOfWeek: 1,
              firstWeekContainsDate: 7,
            },
          }"
        />
      </template>
    </template>
  </div>
</template>

<script>
import DateRangePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import moment from "moment";

export default {
  name: "datepicker",
  data() {
    return {
      model: null,
      cDate: null,
      specialDate: false,
      date: {
        startDate: new Date(),
      },
      opens: "right",
    };
  },
  components: {
    "date-range-picker": DateRangePicker,
  },
  props: ["input", "form", "value", "openType"],
  created() {
    if (this.value) {
      this.model = this.value;
      this.date = this.value;
      this.specialDate = true;
    }
    if (this.openType) {
      this.opens = this.openType;
    }
  },
  methods: {},
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    cDate() {
      if (this.cDate === "999") {
        this.date = moment()
          .subtract(0, "days")
          .format("YYYY-MM-DD");
        this.specialDate = true;
      } else {
        this.$parent.$emit("changed", {
          name: this.input.name,
          value: this.cDate + "gun",
        });
      }
    },
    date() {
      if (this.form.type == 10) {
        let startDate = moment(this.date[0]).format("YYYY-MM-DD");
        // Bitiş tarihine bir gün ekle
        let endDate = moment(this.date[1]).format("YYYY-MM-DD");

        this.$parent.$emit("changed", {
          name: this.input.name,
          value: { start: startDate, end: endDate },
        });
        this.$emit("changed", {
          name: this.input.name,
          value: { start: startDate, end: endDate },
        });
      } else {
        let formattedDate = moment(this.date).format("YYYY-MM-DD");
        this.$parent.$emit("changed", {
          name: this.input.name,
          value: formattedDate,
        });
        this.$emit("changed", {
          name: this.input.name,
          value: formattedDate,
        });
      }
    },
  },
};
</script>

<style>
.daterangepicker.single.show-ranges {
  min-width: 370px !important;
}

.daterangepicker.show-ranges {
  min-width: 700px !important;
}

.mx-datepicker {
  width: 100% !important;

  box-shadow: none !important;
  border-color: #e5e5e5 !important;
  @apply rounded-lg;
}

.date-range-picker .reportrange-text {
  display: inline-block;
  vertical-align: middle;

  font-size: 13px;
  text-align: center;
  border: 0 none;
  padding-top: 10px;
  padding-bottom: 10px;
  background: #fff;
  color: #666;
}
</style>
